import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { ErrorResponseContentInterface } from '@systemeio/util';
import React, { useEffect, useState } from 'react';
import SenderEmailSelect from 'shared/components/sender-email-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { HTMLString } from 'shared/types/html-string';
import { useSenderEmailCheck } from './activate-campaign-step/hooks/use-sender-email-check';
interface Props {
  opened: boolean;
  disabled?: boolean;
  isFetching?: boolean;
  email?: string;
  error?: string;
  className?: string;
  onSave: () => Promise<void>;
  onClose: () => void;
  onChange: (_?: string) => void;
  afterLeave?: () => void;
}
export const useChangeSenderEmailModal = ({
  senderEmail,
  campaignStepId,
  onSuccess
}: {
  senderEmail?: string;
  campaignStepId: number;
  onSuccess?: ({
    fromEmail
  }: {
    fromEmail: string;
  }) => void;
}) => {
  const [opened, setOpened] = useState(false);
  const [email, setEmail] = useState(senderEmail);
  const [error, setError] = useState<string>();
  const {
    checkSenderEmail,
    isFetching
  } = useSenderEmailCheck();
  useEffect(() => {
    setEmail(senderEmail);
  }, [senderEmail]);
  const getSenderEmailError = (e: Error) => {
    if (e instanceof BadRequest) {
      const errors = e.errors as ErrorResponseContentInterface<{
        fromEmail: HTMLString[];
      }>;
      if (errors?.fields?.fromEmail) {
        return errors.fields.fromEmail.join('');
      }
    }
  };
  const tryCheckSenderEmailAndOpenModalIfNotValid = async (senderEmail_0?: string) => {
    try {
      if (!senderEmail_0) throw new Error();
      await checkSenderEmail(campaignStepId, {
        fromEmail: senderEmail_0
      });
    } catch (e_0) {
      setOpened(true);
      const errorMsg = e_0 instanceof Error && getSenderEmailError(e_0);
      errorMsg && toast.error(errorMsg);
      errorMsg && setError(errorMsg);
      throw e_0;
    }
  };
  const onChange = (value?: string) => {
    setEmail(value);
  };
  const afterLeave = () => {
    setError(undefined);
    setEmail(senderEmail);
  };
  const onClose = () => {
    setOpened(false);
  };
  const onSave = async () => {
    setError(undefined);
    try {
      if (!email) return;
      await checkSenderEmail(campaignStepId, {
        fromEmail: email
      });
      setOpened(false);
      onSuccess?.({
        fromEmail: email
      });
    } catch (e_1) {
      const errorMsg_0 = e_1 instanceof Error && getSenderEmailError(e_1);
      errorMsg_0 && setError(errorMsg_0);
    }
  };
  return {
    opened,
    isFetching,
    email,
    error,
    onChange,
    onClose,
    onSave,
    afterLeave,
    tryCheckSenderEmailAndOpenModalIfNotValid
  };
};
export const ChangeSenderEmailModal = t0 => {
  const $ = _c(32);
  const {
    className,
    disabled,
    opened,
    isFetching,
    email,
    error,
    onChange,
    onClose,
    afterLeave,
    onSave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.campaign_step_activating.set_sender_email");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.campaign_step_activating.set_sender_email_description");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex justify-center"><p>{t2}</p></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = email || "";
  let t5;
  if ($[6] !== disabled || $[7] !== error || $[8] !== onChange || $[9] !== t4) {
    t5 = <SenderEmailSelect className="w-full" required={true} value={t4} onChange={onChange} error={error} disabled={disabled} />;
    $[6] = disabled;
    $[7] = error;
    $[8] = onChange;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onSave) {
    t6 = e => {
      e.preventDefault();
      onSave();
    };
    $[11] = onSave;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = disabled || !email;
  let t8;
  if ($[13] !== t) {
    t8 = t("global.confirm");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isFetching || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex justify-center"><PrimaryButton type="submit" width="large" onClick={t6} isFetching={isFetching} disabled={t7}>{t8}</PrimaryButton></div>;
    $[15] = isFetching;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t5 || $[22] !== t9) {
    t10 = <form className="m-auto flex w-full flex-col gap-6 lg:gap-10">{t3}{t5}{t9}</form>;
    $[20] = t3;
    $[21] = t5;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== afterLeave || $[25] !== className || $[26] !== isFetching || $[27] !== onClose || $[28] !== opened || $[29] !== t1 || $[30] !== t10) {
    t11 = <><Modal isCentered={true} opened={opened} isFetching={isFetching} onClose={onClose} afterLeave={afterLeave} title={t1} className={className}>{t10}</Modal></>;
    $[24] = afterLeave;
    $[25] = className;
    $[26] = isFetching;
    $[27] = onClose;
    $[28] = opened;
    $[29] = t1;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};